// Copyright (c) 2016 Deere & Company

import './warranty-modal.scss';
import React, {PropTypes} from 'react';
import {LargeModal} from 'deere-ui-modal-core';

const WarrantyLargeModal = props => {

    const simpleClass = props.simple ?
        'simple' : '';

    return (
        <LargeModal
            {...props}
            className={`warranty-large-modal ${simpleClass}`}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
        />
    );

};

WarrantyLargeModal.displayName = 'WarrantyLargeModal';
WarrantyLargeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    simple: PropTypes.bool
};

export default WarrantyLargeModal;



// WEBPACK FOOTER //
// ./src/shared/components/modal/large-modal.js